/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q_Ai_OzelliklerInputs */

const tr_faq_q_ai_ozellikler = /** @type {(inputs: Faq_Q_Ai_OzelliklerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yapay zeka hangi işlerde kullanılıyor?`)
};

const en_faq_q_ai_ozellikler = /** @type {(inputs: Faq_Q_Ai_OzelliklerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What can I use AI for?`)
};

const de_faq_q_ai_ozellikler = /** @type {(inputs: Faq_Q_Ai_OzelliklerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wofür kann ich die KI nutzen?`)
};

const ru_faq_q_ai_ozellikler = /** @type {(inputs: Faq_Q_Ai_OzelliklerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для чего используется ИИ?`)
};

/**
* | output |
* | --- |
* | "What can I use AI for?" |
*
* @param {Faq_Q_Ai_OzelliklerInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_q_ai_ozellikler = /** @type {((inputs?: Faq_Q_Ai_OzelliklerInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q_Ai_OzelliklerInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q_ai_ozellikler(inputs)
	if (locale === "de") return de_faq_q_ai_ozellikler(inputs)
	if (locale === "ru") return ru_faq_q_ai_ozellikler(inputs)
	return tr_faq_q_ai_ozellikler(inputs)
});